"use client";

import React from "react";
import { ShieldCheck, Clock, Wrench } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const advantages = [{
  id: 1,
  title: "Certified Expertise",
  description: "Our InterNACHI certified inspectors provide professional evaluations and detailed reporting to help you understand the current condition of your property.",
  icon: Wrench
}, {
  id: 2,
  title: "Next-Day Reporting",
  description: "Time is of the essence in real estate. We aim to deliver comprehensive, digital inspection reports within 24 hours of the site visit.",
  icon: Clock
}, {
  id: 3,
  title: "Advanced Technology",
  description: "We utilize thermal imaging and drone technology to assist in a thorough evaluation of accessible home systems and components.",
  icon: ShieldCheck
}];
export default function WhyChooseUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="130084" id="why-choose-trusted-inspections" className="py-32 bg-background text-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-4xl md:text-5xl font-bold uppercase text-secondary mb-4">
            The Trusted Difference
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            We provide the clarity and confidence you need when making one of life's most significant investments through professional home inspection services.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          {advantages.map((advantage, i) => {
          const Icon = advantage.icon;
          return <Card key={advantage.id} data-index={i} className="border-border shadow-sm hover:shadow-lg transition-shadow duration-300 bg-card h-full flex flex-col">
                <CardHeader className="pb-4">
                  <div className="w-14 h-14 rounded-xl bg-secondary/10 flex items-center justify-center mb-4 text-primary">
                    <Icon className="w-7 h-7" strokeWidth={2} />
                  </div>
                  <CardTitle className="text-xl font-bold text-secondary uppercase tracking-tight">
                    {advantage.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow">
                  <p className="text-muted-foreground leading-relaxed">
                    {advantage.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}